var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutubeGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6067 1.6243C12.46 1.07976 12.0306 0.650413 11.4859 0.503807C10.4908 0.231537 6.5106 0.231537 6.5106 0.231537C6.5106 0.231537 2.53035 0.231537 1.53529 0.493335C1.0011 0.639941 0.561178 1.07976 0.414538 1.6243C0.152679 2.61913 0.152679 4.6821 0.152679 4.6821C0.152679 4.6821 0.152679 6.75554 0.414538 7.7399C0.561178 8.28444 0.990626 8.71379 1.53529 8.86039C2.54083 9.13266 6.5106 9.13266 6.5106 9.13266C6.5106 9.13266 10.4908 9.13266 11.4859 8.87086C12.0306 8.72426 12.46 8.29491 12.6067 7.75037C12.8685 6.75554 12.8685 4.69257 12.8685 4.69257C12.8685 4.69257 12.879 2.61913 12.6067 1.6243Z",
    fill: "#4e525f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62995 4.6821L5.23904 2.77471V6.58948L8.62995 4.6821Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeGray);
export default __webpack_public_path__ + "static/media/youtube-gray.6100c673a883200cbef9e86998833098.svg";
export { ForwardRef as ReactComponent };